module.exports = __webpack_public_path__ + "send-fb.358d4b57.jpg";